import { Box, Flex, Tag } from "@chakra-ui/react";
import { ReactNode } from "react";

import { RanaHeading, SchematisationIcon } from "@nens/ranalib";

import { StickyWrapper } from "../../rana-tabs/sticky-wrapper";
import { useSchematisationDetailsContext } from "../schematisation-details-context";

interface SchematisationDetailsHeaderProps {
  title: ReactNode;
  actions: ReactNode | ((hasReachedStickyPosition: boolean) => ReactNode);
}

export function SchematisationDetailsHeader({ title, actions }: SchematisationDetailsHeaderProps) {
  const { mode, revision } = useSchematisationDetailsContext();

  return (
    <StickyWrapper isSticky top={mode === "project" ? 16 : undefined}>
      {(hasReachedStickyPosition) => (
        <Box p={hasReachedStickyPosition ? 2 : 0} transition="all 0.2s">
          <Flex alignItems="center" justifyContent="space-between" w="full" flexWrap="wrap">
            <RanaHeading type="h2">
              <SchematisationIcon boxSize={6} /> {title}
            </RanaHeading>

            {typeof actions === "function" ? actions(hasReachedStickyPosition) : actions}
          </Flex>
          {revision.commitMessage && (
            <Tag ml={8} mt={1}>
              {revision.commitMessage}
            </Tag>
          )}
        </Box>
      )}
    </StickyWrapper>
  );
}
